import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_URL } from './config';
import './alumni.css';
import './AlumniAcademicTheme.css';
import './AlumniRegisterUpdates.css';
import { ProviderButton } from './AlumniIcons';
import { AlumniSignInMethods } from './AlumniLogin';
const ROOT = `${API_URL}/api/alumni`;
const json = async (r) => {
  const d = await r.json(); if (!r.ok)
    throw Error(d.error || 'Request failed'); return d;
};
const send = (url, data, token) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body: JSON.stringify(data) }).then(json);
const Select = ({ label, value, options, onChange, disabled = false }) => <label className="al-field">
  {label}
  <select value={value || ''} disabled={disabled} onChange={e => onChange(e.target.value)}>
    <option value="">
      Select
      {label.toLowerCase()}
    </option>
    {options.map(x => <option key={x.value} value={x.value}>
      {x.label}
    </option>)}
  </select>
</label>;
const Text = ({ label, value, onChange, ...props }) => <label className="al-field">
  {label}
  <input value={value || ''} onChange={e => onChange(e.target.value)} {...props} />
</label>;
export default function AlumniRegister() {
  const { slug: routeSlug, token: routeToken } = useParams();
  const slug = routeSlug || routeToken || '';
  const navigate = useNavigate();
  const [stage, setStage] = useState('phone'), [link, setLink] = useState(null), [phone, setPhone] = useState(''), [otp, setOtp] = useState(''), [verification, setVerification] = useState(''), [session, setSession] = useState(localStorage.getItem('alumniToken') || ''), [error, setError] = useState(''), [busy, setBusy] = useState(false), [privacy, setPrivacy] = useState(false), [optIn] = useState(true), [privacyOpen, setPrivacyOpen] = useState(false);
  const [p, setP] = useState({ fullName: '', studentId: '', graduationYear: '', subCampus: '', degree: '', branch: '', email: '', city: '', state: '', country: 'IN', postalCode: '', linkedinUrl: '', employmentStatus: 'Employed', company: '', role: '', mentor: false, directoryVisible: true, readyToHire: false });
  const [subcampuses, setSubcampuses] = useState([]);
  const [postalStatus, setPostalStatus] = useState('');
  const [skillsText, setSkillsText] = useState('');
  const [countries, setCountries] = useState([]), [states, setStates] = useState([]), [cities, setCities] = useState([]), [postal, setPostal] = useState([]), [degrees, setDegrees] = useState([]), [branches, setBranches] = useState([]);
  const set = (key, value) => setP(old => ({ ...old, [key]: value }));
  useEffect(() => {
    if (!slug) {
      setError('Invalid alumni registration link. Please open the complete invitation URL.');
      return;
    } setError(''); fetch(`${ROOT}/public/link/${encodeURIComponent(slug)}`).then(json).then(setLink).catch(e => setError(e.message)); fetch(`${ROOT}/lookups/countries`).then(json).then(d => setCountries(d.rows || [])).catch(() => { }); fetch(`${ROOT}/lookups/academic?slug=${encodeURIComponent(slug)}`).then(json).then(d => setSubcampuses(d.subcampuses || [])).catch(e => setError(e.message));
  }, [slug]);
  useEffect(() => {
    if (!p.country) {
      setStates([]);
      return;
    } fetch(`${ROOT}/lookups/states?country=${encodeURIComponent(p.country)}`).then(json).then(d => setStates(d.rows || [])).catch(() => setStates([]));
  }, [p.country]);
  useEffect(() => {
    if (!p.country || !p.state) {
      setCities([]);
      return;
    } fetch(`${ROOT}/lookups/cities?country=${encodeURIComponent(p.country)}&state=${encodeURIComponent(p.state)}`).then(json).then(d => setCities(d.rows || [])).catch(() => setCities([]));
  }, [p.country, p.state]);
  useEffect(() => {
    if (!p.country || !p.postalCode || p.postalCode.length < 3) {
      setPostal([]);
      return;
    } const id = setTimeout(() => fetch(`${ROOT}/lookups/postal?country=${encodeURIComponent(p.country)}&query=${encodeURIComponent(p.postalCode)}`).then(json).then(d => setPostal(d.rows || [])).catch(() => setPostal([])), 350); return () => clearTimeout(id);
  }, [p.country, p.postalCode]);
  useEffect(() => {
    if (!slug || !p.degree) {
      setBranches([]);
      return;
    } fetch(`${ROOT}/lookups/branches?slug=${encodeURIComponent(slug)}&degree=${encodeURIComponent(p.degree)}&subCampus=${encodeURIComponent(p.subCampus)}`).then(json).then(d => setBranches(d.rows || [])).catch(() => setBranches([]));
  }, [slug, p.degree, p.subCampus]);
  useEffect(() => {
    if (!slug || !link)
      return; fetch(`${ROOT}/lookups/degrees?slug=${encodeURIComponent(slug)}&subCampus=${encodeURIComponent(p.subCampus)}`).then(json).then(d => setDegrees(d.rows || [])).catch(e => setError(e.message));
  }, [slug, link, p.subCampus]);
  useEffect(() => {
    const zip = p.postalCode.trim(); if (zip.length < 3 || !p.country) {
      setPostalStatus('');
      return;
    } const controller = new AbortController(); const timer = setTimeout(async () => {
      try {
        setPostalStatus('Looking up postal code…');
        const r = await fetch(`${ROOT}/lookups/postal/resolve?country=${encodeURIComponent(p.country)}&postalCode=${encodeURIComponent(zip)}`, { signal: controller.signal });
        const d = await json(r);
        if (d.found) {
          setP(old => old.postalCode.trim() === zip ? { ...old, country: d.country || old.country, state: d.state || old.state, city: d.city || old.city } : old);
          setPostalStatus('Location filled from postal code. Please verify.');
        }
        else
          setPostalStatus('No exact match. Select location manually.');
      }
      catch (e) {
        if (e.name !== 'AbortError')
          setPostalStatus('Automatic lookup unavailable. Select location manually.');
      }
    }, 650); return () => { clearTimeout(timer); controller.abort(); };
  }, [p.postalCode, p.country]);
  const action = async (fn) => {
    setError(''); setBusy(true); try {
      await fn();
    }
      catch (e) {
        setError(e.message);
      }
      finally {
        setBusy(false);
      }
  };
  const options = arr => arr.map(x => ({ value: x.value, label: x.label }));
  return <div className="al-bg al-academic-theme">
    <div className="al-card al-card-register">
      <header className="al-header">
        <div className="al-kicker">
          UNIFLOO · ALUMNI CONNECT
        </div>
        <h1>
          {stage === 'done' ? 'Welcome to Alumni Connect' : 'Your next chapter starts here'}
        </h1>
        <p>
          {link?.label || 'Join your alumni community and keep your profile current.'}
          {link?.campusCode ? ` · Campus ${link.campusCode}` : ''}
        </p>
      </header>
      <div className="al-steps">
        <span className={stage === 'phone' ? 'active' : ''}>
          01 · Verify
        </span>
        <span className={stage === 'verify' ? 'active' : ''}>
          02 · Confirm
        </span>
        <span className={stage === 'profile' ? 'active' : ''}>
          03 · Profile
        </span>
        <span className={stage === 'done' ? 'active' : ''}>
          04 · Connect
        </span>
      </div>
      {error && <div role="alert" className="al-error">
        {error}
      </div>}
      {stage === 'phone' && <section className="al-body">
        <div className="al-section-tag">
          SECURE ONBOARDING
        </div>
        <h2>
          Join your alumni network
        </h2>
        <p>
          Verify your WhatsApp number once. You can then link a passkey, Google, Apple or LinkedIn for future sign-ins.
        </p>
        <div className="al-phone-row">
          <Text label="WhatsApp number (+country code)" value={phone} onChange={setPhone} placeholder="+919876543210" />
          <button disabled={busy || !slug || !link} className="al-primary" onClick={() => action(async () => { await send(`${ROOT}/public/start`, { slug, whatsapp: phone }); setStage('verify'); })}>
            Send verification code
          </button>
        </div>
        <div className="al-divider">
          Already registered? Sign in here
        </div>
        <AlumniSignInMethods />
        <p className="al-muted">
          Or sign in with WhatsApp OTP on the login page.
        </p>
      </section>}
      {stage === 'verify' && <section className="al-body">
        <h2>
          Verify your number
        </h2>
        <Text label="6-digit code" value={otp} onChange={setOtp} maxLength={6} inputMode="numeric" />
        <button disabled={busy} className="al-primary" onClick={() => action(async () => { const v = await send(`${ROOT}/public/verify`, { slug, whatsapp: phone, code: otp }); setVerification(v.sessionToken); setStage('profile'); })}>
          Verify and continue
        </button>
      </section>}
      {stage === 'profile' && <form className="al-body" onSubmit={e => {
        e.preventDefault(); action(async () => {
          const v = await send(`${ROOT}/public/submit`, { slug, sessionToken: verification, profile: p, privacyAccepted: privacy, whatsappOptIn: optIn }); localStorage.setItem('alumniToken', v.alumniToken); setSession(v.alumniToken); if (p.skills?.length) {
            try {
              await fetch(`${ROOT}/auth/profile`, { method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${v.alumniToken}` }, body: JSON.stringify({ skills: p.skills }) });
            }
            catch { }
          } setStage('done');
        });
      }}>
        <div className="al-section-tag">
          YOUR DETAILS
        </div>
        <h2>
          Build your alumni profile
        </h2>
        <p className="al-muted">
          Complete your verified profile first, then securely connect Google, Apple or LinkedIn. LinkedIn only shares fields approved through its OAuth permissions.
        </p>
        <div className="al-grid al-profile-grid">
          <div className="al-row-three">
            <Text label="Full name" required value={p.fullName} onChange={v => set('fullName', v)} />
            <Text label="Student ID (optional)" value={p.studentId} onChange={v => set('studentId', v)} />
            <Text label="Email" type="email" value={p.email} onChange={v => set('email', v)} />
          </div>
          <div className="al-row-four">
            <Text label="Graduation year" type="number" value={p.graduationYear} onChange={v => set('graduationYear', v)} />
            <Select label="Sub-campus" value={p.subCampus} options={options(subcampuses)} onChange={v => setP(o => ({ ...o, subCampus: v, degree: '', branch: '' }))} />
            <Select label="Degree" value={p.degree} options={options(degrees)} onChange={v => { set('degree', v); set('branch', ''); }} />
            <Select label="Branch" value={p.branch} options={options(branches)} onChange={v => set('branch', v)} disabled={!p.degree} />
          </div>
          <div className="al-row-four">
            <Select label="Country" value={p.country} options={options(countries)} onChange={v => setP(o => ({ ...o, country: v, state: '', city: '', postalCode: '' }))} />
            <Select label="State / province" value={p.state} options={options(states)} onChange={v => setP(o => ({ ...o, state: v, city: '', postalCode: '' }))} />
            <label className="al-field">
              Current city
              <input list="al-city-options" value={p.city} onChange={e => set('city', e.target.value)} placeholder="Select or type city" />
              <datalist id="al-city-options">
                {cities.map(c => <option key={c.value} value={c.value} />)}
              </datalist>
            </label>
            <label className="al-field">
              ZIP / postal code
              <input list="al-postal" value={p.postalCode} onChange={e => set('postalCode', e.target.value)} placeholder="Search postal code" />
              <small className="al-field-hint" role="status">
                {postalStatus}
              </small>
              <datalist id="al-postal">
                {postal.map(x => <option key={x.value} value={x.value}>
                  {x.label}
                </option>)}
              </datalist>
            </label>
          </div>
          <div className="al-row-four">
            <Text label="LinkedIn profile URL" type="url" placeholder="https://www.linkedin.com/in/your-name" value={p.linkedinUrl} onChange={v => set('linkedinUrl', v)} />
            <Select label="Employment status" value={p.employmentStatus} options={['Employed', 'Self-employed', 'Entrepreneur', 'Higher education', 'Seeking opportunities', 'Homemaker', 'On a break', 'Other'].map(x => ({ value: x, label: x }))} onChange={v => set('employmentStatus', v)} />
            <Text label="Current company" value={p.company} onChange={v => set('company', v)} />
            <Text label="Designation / role" value={p.role} onChange={v => set('role', v)} />
          </div>
        </div>
        <label className="al-field">
          Skills (comma separated)
          <input value={skillsText} onChange={e => { setSkillsText(e.target.value); set('skills', e.target.value.split(',').map(s => s.trim()).filter(Boolean)); }} placeholder="React, Data analysis, Project management" />
        </label>
        <div className="al-checks">
          {[['mentor', 'Interested in mentoring'], ['readyToHire', 'Ready to hire (jobs and internships)']].map(([k, label]) => <label key={k}>
            <input type="checkbox" checked={p[k]} onChange={e => set(k, e.target.checked)} />
            {label}
          </label>)}
          <label>
            <input type="checkbox" required checked={privacy} onChange={e => setPrivacy(e.target.checked)} />
            I acknowledge the <button type="button" className="al-privacy-link" onClick={() => setPrivacyOpen(true)}>alumni privacy notice</button>.
          </label>
        </div>
        <button disabled={busy} className="al-primary">
          Save profile
        </button>
      </form>}
      {privacyOpen && <div className="al-privacy-overlay" onMouseDown={e => { if (e.target === e.currentTarget) setPrivacyOpen(false); }}>
        <div className="al-privacy-dialog" role="dialog" aria-modal="true" aria-labelledby="al-privacy-title">
          <div className="al-privacy-heading"><h2 id="al-privacy-title">Alumni privacy notice</h2><button type="button" aria-label="Close privacy notice" onClick={() => setPrivacyOpen(false)}>×</button></div>
          <p>Before registering, please review how information in your alumni profile may be handled.</p>
          <ol>
            <li><strong>Profile information:</strong> You provide your name, contact information, education, employment, location, and optional skills.</li>
            <li><strong>Purpose:</strong> This information is used to maintain your alumni profile and support alumni networking, mentoring, and career opportunities.</li>
            <li><strong>Directory visibility:</strong> Your profile is set to appear in the alumni directory by default. Review your profile and directory settings after registration to control visibility where available.</li>
            <li><strong>Communications:</strong> A WhatsApp profile confirmation every six months is enabled by default. Contact the campus administrator if you wish to opt out and no account setting is available.</li>
            <li><strong>Account connections:</strong> Connecting Google, Apple, or LinkedIn is optional. Those providers share only information permitted by their authorization process.</li>
            <li><strong>Accuracy and changes:</strong> Keep your details current. Contact the campus alumni administrator for privacy requests or assistance.</li>
            <li><strong>Security:</strong> Do not share your verification codes or account credentials with anyone.</li>
          </ol>
          {/*<p className="al-muted">This is a draft notice for the registration screen. Your institution should review and publish its complete privacy policy, including retention, recipients, and applicable rights.</p> */}
          <button type="button" className="al-primary" onClick={() => setPrivacyOpen(false)}>Close</button>
        </div>
      </div>}
      {stage === 'done' && <section className="al-body">
        <div className="al-success-mark">
          ✓
        </div>
        <h2>
          Profile saved successfully
        </h2>
        <p>
          Connect a trusted account to sign in next time without an invitation code. LinkedIn account linking does not automatically grant access to full employment or profile data.
        </p>
        <AlumniIdentityActions token={session} />
        <button className="al-primary" onClick={() => navigate('/alumni/dashboard')}>
          Open my dashboard
        </button>
      </section>}
    </div>
  </div>;
}
export function AlumniIdentityActions({ token, passkeyCount = 0, linkedProviders = [], onPasskeyAdded }) {
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const link = async (provider) => {
    setMsg('');
    try {
      const v = await send(`${ROOT}/auth/oauth/start`, { provider, mode: 'link' }, token);
      window.location.assign(v.url);
    }
    catch (e) {
      setMsg(e.message);
    }
  };
  const passkey = async () => {
    setMsg('');
    setBusy(true);
    try {
      const { startRegistration } = await import('@simplewebauthn/browser');
      const o = await send(`${ROOT}/auth/passkeys/register/options`, {}, token);
      const response = await startRegistration({ optionsJSON: o });
      await send(`${ROOT}/auth/passkeys/register/verify`, { challenge: o.challenge, response }, token);
      setMsg('Passkey added successfully');
      if (onPasskeyAdded)
        await onPasskeyAdded();
    }
    catch (e) {
      setMsg(e.message);
    }
    finally {
      setBusy(false);
    }
  };
  const linked = new Set(linkedProviders.map(x => String(x).toLowerCase()));
  return <div className="al-auth al-provider-grid">
    <ProviderButton provider="passkey" disabled={busy} onClick={passkey}>
      {busy ? 'Adding passkey…' : passkeyCount > 0 ? 'Add another passkey' : 'Add passkey'}
    </ProviderButton>
    {['google', 'apple', 'linkedin'].map(x => <ProviderButton provider={x} key={x} disabled={busy || linked.has(x)} onClick={() => link(x)}>
      {linked.has(x) ? 'Connected · ' : 'Connect '}
      {x[0].toUpperCase() + x.slice(1)}
    </ProviderButton>)}
    {msg && <p role="status">
      {msg}
    </p>}
  </div>;
}
